import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as customerActions from "../../actions/customerActions";
import * as codeActions from "../../actions/codeActions";

import CustomerForm from "./CustomerForm";
import HeaderWrapper from "../common/HeaderWrapper";

class CustomerAddPage extends Component {
  handleSave = (customer) => {
    this.props.actions.createCustomer(customer);
  };

  handleCancel = () => {
    this.props.history.push("/app/customers");
  };

  render() {
    const { codes, saving } = this.props;

    return (
      <>
        <HeaderWrapper breadcrumbs={[{ label: "Add Customer" }]} />
        <div className="content-wrapper">
          <CustomerForm
            customer={{}}
            codes={codes}
            saving={saving}
            onSave={this.handleSave}
            onCancel={this.handleCancel}
            editing
            adding
          />
        </div>
      </>
    );
  }
}

CustomerAddPage.propTypes = {
  actions: PropTypes.object.isRequired,
  saving: PropTypes.bool,
  codes: PropTypes.array,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    saving: state.reducers.savingCustomer,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...customerActions, ...codeActions },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(CustomerAddPage);
